export const DASHBOARD_GREETING_KEY = {
  MORNING: 'dashboard.greeting_morning_web_l',
  DAY: 'dashboard.greeting_day_web_l',
  EVENING: 'dashboard.greeting_evening_web_l',
} as const;

export type DashboardGreetingKey =
  (typeof DASHBOARD_GREETING_KEY)[keyof typeof DASHBOARD_GREETING_KEY];

// Morning 00:00–09:59, day 10:00–17:59, evening 18:00–23:59 (device local time)
export function getDashboardGreetingKey(date: Date = new Date()): DashboardGreetingKey {
  const hour = date.getHours();
  if (hour < 10) {
    return DASHBOARD_GREETING_KEY.MORNING;
  }
  if (hour < 18) {
    return DASHBOARD_GREETING_KEY.DAY;
  }
  return DASHBOARD_GREETING_KEY.EVENING;
}
